var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: "Vincular/Trocar Responsável",
        closeOutside: true,
        hasFooter: true,
        width: 600
      },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c("InputSelect", {
            attrs: { label: "Responsável:", opcoes: _vm.responsaveis },
            model: {
              value: _vm.responsavel,
              callback: function($$v) {
                _vm.responsavel = $$v
              },
              expression: "responsavel"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex-end" },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.alterar } },
              [_vm._v("Alterar")]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b2b9d280", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b9d280","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/TrocarResponsavel/TrocarResponsavel.vue
// module id = null
// module chunks = 